import { Button, Modal } from "react-bootstrap";
import React, { useEffect, useState } from "react";
import "./DownloadPdfPopup.scss";
import { useSelector } from "react-redux";
import { FaCloudDownloadAlt } from "react-icons/fa";
import ProgressBar from "react-bootstrap/ProgressBar";
import download from "js-file-download";
import Cookies from 'js-cookie';
import {TECHPUB_TOKEN} from "../../../helper/constants";


import axios from "axios";
const DownloadPdfPopup = (props) => {
  const [show, setShow] = useState(false);
  const [progress, setProgress] = useState(0);
  const [isDownloading, setIsDownloading] = useState(false);
  const [dwnldStarted, setDwnldStarted] = useState(false);
  const [dwnldCompleted, setDwnldCompleted] = useState(false);
  const [saveApiStatus, setSaveApiStatus] = useState("in progress");
  const [errorPopup,setErorPopup]=useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => {
    setShow(true);

  };


  let percentCompleted;
  const getParameterByName = (name, url = window.location.href) => {
    name = name.replace(/[\[\]]/g, '\\$&');
    const regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
      results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return encodeURIComponent(decodeURIComponent(results[2].replace(/\+/g, ' ')));
  };
  
  const readCookie = (name) => {
    const cookieString = document.cookie;
    const cookies = cookieString.split("; ");
 
    for (const cookie of cookies) {
      const [cookieName, cookieValue] = cookie.split("=");
      if (cookieName === name) {
        return cookieValue;
      }
    }
  };
  
  
const downloadSave = async (payload, callBack) => {

    const pubId=getParameterByName('pubId') ? getParameterByName('pubId'):0 ;

    const cookieVal=Cookies.get('jwtToken');
    try {
      const response = await fetch(`/api/v1/download-save?pubId=`+pubId, {
        method: "GET",
        headers: {
			"authorization": 'Bearer ' + cookieVal
		},
      
      });
      const data = await response.json();
      if (payload === "in progress") {
        callBack();
      }
     
    } catch (error) {
     
    }
  };

  const downloadPDF = async () => {
     setDwnldStarted(true);
     setIsDownloading(true);
	setTimeout(async function(){  
		const pdfParamToken=getParameterByName('token');
		const cookieVal=Cookies.get('jwtToken');
  // => 'value'
   console.log("jwt token11",cookieVal);
    await axios({
      url: `/api/v1/download/download-document-1?token=${pdfParamToken}`,
      
      method: "GET",
      headers: {
        "authorization": 'Bearer ' + cookieVal
      },
      responseType: "blob", // important

      onDownloadProgress(progressEvent) {
        const percentCompleted = Math.round(
          (progressEvent.loaded * 100) /
          progressEvent.target.getResponseHeader("content-length")
        );
        setProgress(percentCompleted);
      },
    })
      .then((resp) => {
        setDwnldCompleted(true);
		
		const myCookieValue: any = readCookie("cancelDownloadClick");
        if (myCookieValue === "false") {
        const fileName =
          resp?.headers["content-disposition"].split("filename=")[1];
      
        const file = new Blob([resp.data], {
          type: "application/pdf",
        });
        download(file, fileName, "application/octet-stream");
      
        setDwnldStarted(false);
		}
		 const status = "completed";
        downloadSave(status, "");
  
      })
      .catch((error) => {
	    setProgress(0);
        setDwnldCompleted(false);
		setErorPopup(true);
      });
  },2000);
  };

  
  const closeErrorPopup = ()=>{
  	window.close();
  };
  useEffect(() => {
    /*eslint-disable */
	setTimeout(function(){ downloadPDF();},2000);
   
	document.cookie = `cancelDownloadClick=${false}`;
  }, [props.data]);
   return (
    <React.Fragment>
      <>

        <>
          <h2>
            <span className="icon-download">
              <FaCloudDownloadAlt className="icon-d" />
            </span>
            Downloading Publication
          </h2>
          <div className="body-class">
            <div className="info">
              {" "}
              {isDownloading && dwnldCompleted
                ? "We appreciate your patience. The publication has been successfully downloaded"
                : "We are currently processing your download request. We appreciate your patience, as this process may take more than 1 minute."}
            </div>
            {isDownloading ? (
              <>
                <div className="downloadlingstatus">
                  {dwnldStarted
                    ? <div className="fetchingData">
						{" "}
						{" Dowloading Your Publication"}
					<span className="loading-dots">
					&nbsp;
					<span className="loading-dots--dot"></span>
					&nbsp;
					<span className="loading-dots--dot"></span>
					&nbsp;
					<span className="loading-dots--dot"></span>
					</span>
					</div>
                    : dwnldCompleted
                      ? "Download Complete"
                      : "Downloading your publication"}
                </div>
              </>
            ) : (
              <>
                <div className="fetchingData">
                  {" "}
                  {" Dowloading Your Publication"}
					<span className="loading-dots">
					&nbsp;
					<span className="loading-dots--dot"></span>
					&nbsp;
					<span className="loading-dots--dot"></span>
					&nbsp;
					<span className="loading-dots--dot"></span>
					</span>
                </div>

                
              </>
            )}
           
              <div>
                <ProgressBar
                  now={progress}
                  label={`${progress}%`}
                  className="progress-baar"
                />
              </div>
              <div className="msgtouser">
                  {progress < 100 && dwnldStarted
                    ? `Please do not close this window until the download has been fully completed.`
                    : progress === 100 && dwnldCompleted
                      ? "You may close this window."
                      : `Please do not close this window until the download has been fully completed.`}
                </div>
				{progress === 100 && dwnldCompleted ? ( <Button
                      type="button"
                      aria-label="Close Preferences"
                      className="cancelbtn active btn btn-secondary"
                      variant="secondary"
                      onClick={() => {
						window.close();
                      
                      }}
                    >
                     Close
                    </Button>) :
					(  <Button
                      type="button"
                      aria-label="Close Preferences"
                      className="cancelbtn active btn btn-secondary"
                      variant="secondary"
                      onClick={() => {
                        document.cookie = `cancelDownloadClick=${true}`;
						window.close();
                      
                      }}
                    >
                     Cancel Download
                    </Button>)}
          </div>
	<Modal
        className="favPopup addremovePopup licagreementpopup Popupwrapper"
        aria-label="dialog Preferences"
        show={errorPopup}
      >
        <div className="modalbodycontentlic modalbodycontentPopups  modalbodycontent">
		
		<Modal.Header>
          <Modal.Title className="">
            <div className="removewatchlistTitle">Request Failed!</div>
          </Modal.Title>
        </Modal.Header>
          <Modal.Body className="Modal-body-liccontent quicklinkserrorPopup">
            {/*<h1>{t(REQUEST_DOWNLOAD_ERROR.TITLE)}</h1>*/}
            <p>Something went wrong. Please try again!</p>
 
            <div className="modal-footer">
              <div className="footercontainerlic Popupfooter footercontainer">
                <div className="geocheckbtns">
               
                  <Button
                    type="button"
                    aria-label="Close Preferences"
                    className="submitbtn active btn btn-primary"
                    variant="secondary"
                    onClick={closeErrorPopup}
                  >
                    Close
                  </Button>
                </div>
              </div>
            </div>
          </Modal.Body>
        </div>
      </Modal>
 
        </>



      </>
    </React.Fragment>
  );
 
};

export default DownloadPdfPopup;
